import { motion } from 'motion/react'
import { ArrowRight, Check } from 'lucide-react'
import { SectionHeading } from '../common/SectionHeading'
import { oldWayItems } from '../../utils/landingContent'
import type { LandingCopy } from '../../models/LandingPage'

type WhyToneSignatureSectionProps = {
  copy: LandingCopy
  reveal: object
}

export function WhyToneSignatureSection({ copy, reveal }: WhyToneSignatureSectionProps) {
  return <section className="section why"><div className="container"><motion.div {...reveal}><SectionHeading eyebrow="03 — WHY TONESIGNATURE" title={copy.whyTitle} sub={copy.whySub}/></motion.div><div className="comparison"><motion.div {...reveal} className="old-way"><span>TODAY</span><strong>Hours</strong><div>{oldWayItems.map((x,i)=><p key={x}><i>{i+1}</i>{x}</p>)}</div></motion.div><div className="versus"><ArrowRight/></div><motion.div {...reveal} className="new-way"><span>TONESIGNATURE</span><strong>30<span>sec</span></strong><div className="ready-orb"><Check/></div><h3>Ready to play.</h3><p>Native preset. Your hardware. Your rig.</p></motion.div></div></div></section>
}
